//
import WhTransferBetweenWarehouseModel from '@/models/Warehouse/WhTransferBetweenWarehouse'

/**
 * List of wh transfer between warehouse tos.
 *
 * @class      WhTransferBetweenWarehouseToList (name)
 */
export default class WhTransferBetweenWarehouseToList extends WhTransferBetweenWarehouseModel {

    /**
     * { item_description }
     */
    static includes = [
        'g_from_supervisor.hr_employee',
        'g_to_supervisor.hr_employee',
        'state',
        //'wh_detail_transfer_between_warehouses.wh_product',
        'wh_from_warehouse',
        'wh_to_warehouse',
    ]
}
